import withStyles from 'react-jss';

import Curtain from './component';
import styles from './styles';

export default withStyles(styles)(Curtain);
